import { render } from "./CompanyRegistration.vue?vue&type=template&id=08c26368"
import script from "./CompanyRegistration.vue?vue&type=script&lang=js"
export * from "./CompanyRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__